import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

const iconStyles = { color: 'success.main', fontSize: 56 };

/**
 * Confirmation shown in place of the contact form once a request went out.
 * @param {object} props
 * @param {Function} props.onClose - function to close the modal
 */
const ContactSuccessComponent = ({ onClose }) => {
  const intl = useIntl();

  return (
    <Stack alignItems="center" spacing={3} textAlign="center">
      <CheckCircleOutlineIcon sx={iconStyles} />
      <Typography>{intl.formatMessage({ id: 'ContactModal.successBody' })}</Typography>
      <Button color="secondary" onClick={onClose} variant="contained">
        {intl.formatMessage({ id: 'ContactModal.successClose' })}
      </Button>
    </Stack>
  );
};

ContactSuccessComponent.displayName = 'ContactSuccess';

const ContactSuccess = memo(ContactSuccessComponent);

export default ContactSuccess;
